import React from 'react';
import {Box, Grid, Button, InputAdornment} from '@material-ui/core';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
import FormIcon from '../../../components/UI/FormIcon';
import { getVehicleImages, getNoImage, findThumbnailByOriginal } from '../../../shared/vehicle';

const VehicleCarousel = (props) => {

    const vehicle = props.vehicle;
    let images = getVehicleImages(vehicle).slice(0, 100);
    console.log('vehicle', vehicle);
    if (images.length === 0) {
        images.push({
            original: getNoImage(),
            thumbnail: getNoImage()
        });
    }

    // const Item = (props) => {
    //     return (
    //         <Grid className='img'>
    //             <img src={props.url} alt={props.alt} />
    //         </Grid>
    //     )
    // }

    // const [state, setState] = React.useState({
    //     next: null,
    //     prev: null,
    //     hasNext: null,
    //     hasPrev: null
    // });

    const Item = (props) => {
        return (
            <div className='img'>
                <img src={props.url} alt={props.alt} />
                {/* <p className="legend">Legend 1</p> */}
            </div>
        )
    }

    const renderThumbs = (children) => children.map((item, idx) => {
        return (<img key={idx} src={findThumbnailByOriginal(item.props.url, images)} alt={item.props.alt} />);
    });

    const renderArrowNext = (clickHandler, hasNext, label) => {
        // if (clickHandler !== state.next || state.hasNext !== hasNext) {
        //     setState({
        //         ...state,
        //         hasNext,
        //         next: clickHandler
        //     });
        // }
        // <button type="button" aria-label="next slide / item" class="control-arrow control-next"></button>
        const classes = ['control-arrow control-next'];
        !hasNext && classes.push('control-disabled');
        return (
            <Button onClick={clickHandler} className={classes.join(' ')}>
                <InputAdornment position="start">
                    Next <FormIcon type='chevronRight' />
                </InputAdornment>
            </Button>
        );
    }
    const renderArrowPrev = (clickHandler, hasPrev, label) => {
        // if (clickHandler !== state.prev || state.hasPrev !== hasPrev) {
        //     setState({
        //         ...state,
        //         hasPrev,
        //         prev: clickHandler
        //     });
        // }
        const classes = ['control-arrow control-prev'];
        !hasPrev && classes.push('control-disabled');
        return (
            <Button onClick={clickHandler} className={classes.join(' ')}>
                <InputAdornment position="start">
                    <FormIcon type='chevronLeft' /> Back
                </InputAdornment>
            </Button>
        );
    }

    // const clickNextHandler = (e) => {
    //     state.next && state.next(e);
    // }

    // const clickPrevHandler = (e) => {
    //     state.prev && state.prev(e);
    // }

    const boxPadding = 20 + Math.floor(images.length / 13) * 18;

    return (<Box className='vehicle-carousel-box' style={{ paddingBottom: boxPadding }}>
            <Grid container justify="center" direction="column" alignItems="center">
                <Grid item>
                {/* <Carousel indicators={true} indicatorContainerProps={{className: 'indicator-container'}} 
                    navButtonsAlwaysVisible={true} autoPlay={false}
                    fullHeightHover={false} animation="slide">
                    {
                        images.map( (url, i) => <Item key={i} url={url} /> )
                    }
                </Carousel> */}
                    <Carousel className='vehicle-carousel'
                        centerSlidePercentage={10}
                        showStatus={false}
                        showIndicators={true}
                        showArrows={true} showThumbs={true} 
                        renderThumbs={renderThumbs} 
                        renderArrowNext={renderArrowNext} 
                        renderArrowPrev={renderArrowPrev}
                        >
                        {
                            images.map( (image, i) => <Item key={i} url={image.thumbnail} /> )
                        }
                    </Carousel>
                    <Grid container className='control'>
                        {/* <Grid item>
                            <Link onClick={clickPrevHandler}>
                                <InputAdornment position="start">
                                    <FormIcon type='chevronLeft' /> Back
                                </InputAdornment>
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link onClick={clickNextHandler}>
                                <InputAdornment position="start">
                                    Next <FormIcon type='chevronRight' />
                                </InputAdornment>
                            </Link>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
    </Box>);
}

export default VehicleCarousel;